import React from 'react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Checkbox } from '../ui/checkbox';
import { Card } from '../ui/card';
import { Users, Zap, Lightbulb } from 'lucide-react';

const Step4OccupancyHeat = ({ formData, updateFormData }) => {
  return (
    <div className="space-y-6 animate-fadeIn">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Occupancy & Heat Sources</h2>
        <p className="text-gray-600">People and appliances add heat to the space</p>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="numberOfOccupants" className="text-base font-medium flex items-center">
            <Users className="w-5 h-5 mr-2 text-blue-700" />
            Number of Occupants
          </Label>
          <Input
            id="numberOfOccupants"
            type="number"
            min="0"
            max="50"
            value={formData.numberOfOccupants}
            onChange={(e) => updateFormData('numberOfOccupants', parseInt(e.target.value) || 0)}
            className="h-12 text-lg border-blue-200 focus:border-blue-500 focus:ring-blue-500"
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="activityLevel" className="text-base font-medium">
            Activity Level
          </Label>
          <Select value={formData.activityLevel} onValueChange={(value) => updateFormData('activityLevel', value)}>
            <SelectTrigger className="h-12 text-lg border-blue-200 focus:border-blue-500 focus:ring-blue-500">
              <SelectValue placeholder="Select activity level" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="low">Low - Sitting, reading</SelectItem>
              <SelectItem value="moderate">Moderate - Normal activities</SelectItem>
              <SelectItem value="high">High - Exercise, cooking</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="heatAppliances" className="text-base font-medium flex items-center">
          <Zap className="w-5 h-5 mr-2 text-yellow-500" />
          Heat-Generating Appliances
        </Label>
        <Input
          id="heatAppliances"
          type="number"
          min="0"
          max="50"
          value={formData.heatAppliances}
          onChange={(e) => updateFormData('heatAppliances', parseInt(e.target.value) || 0)}
          placeholder="TVs, computers, game consoles, etc."
          className="h-12 text-lg border-blue-200 focus:border-blue-500 focus:ring-blue-500"
        />
        <p className="text-sm text-gray-500">
          Count TVs, computers, game consoles, and other electronic devices
        </p>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="lightingType" className="text-base font-medium flex items-center">
          <Lightbulb className="w-5 h-5 mr-2 text-amber-500" />
          Lighting Type
        </Label>
        <Select value={formData.lightingType} onValueChange={(value) => updateFormData('lightingType', value)}>
          <SelectTrigger className="h-12 text-lg border-blue-200 focus:border-blue-500 focus:ring-blue-500">
            <SelectValue placeholder="Select lighting type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="led">LED - Low heat</SelectItem>
            <SelectItem value="fluorescent">Fluorescent - Moderate heat</SelectItem>
            <SelectItem value="incandescent">Incandescent - High heat</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <Card className="p-4 border-blue-200">
        <div className="flex items-start space-x-3">
          <Checkbox 
            id="hasKitchen"
            checked={formData.hasKitchen}
            onCheckedChange={(checked) => updateFormData('hasKitchen', checked)}
            className="mt-1 border-blue-300"
          />
          <div>
            <Label 
              htmlFor="hasKitchen" 
              className="text-base font-medium cursor-pointer"
            >
              Kitchen in Same Space
            </Label>
            <p className="text-sm text-gray-500 mt-1">
              Check this if there's a kitchen or cooking area in the same open space
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Step4OccupancyHeat;